import { Pipe, PipeTransform } from '@angular/core';
import { IMasterDataUser, IUserData } from '../models';

@Pipe({
  name: 'username',
  standalone: true,
})
export class UsernamePipe implements PipeTransform {
  transform(value: IUserData): string {
    if (!value) {
      return '-';
    }
    let username = '';
    if (value.firstName === value.name) {
      username = value.name;
    } else {
      if (value.firstName) {
        username += value.firstName;
      }
      if (value.name) {
        username.length && (username += ' ');
        username += value.name;
      }
    }
    return username;
  }
}

@Pipe({
  name: 'userInitials',
  standalone: true,
})
export class UserInitialsPipe implements PipeTransform {
  transform(value: IUserData | IMasterDataUser): string | null {
    if (!value) {
      return null;
    }
    let userInitials = '';
    const firstName = value.firstName;
    const lastName =
      'lastName' in value ? value.lastName : 'name' in value ? value.name : undefined;

    if (firstName === lastName) {
      userInitials += lastName?.charAt(0).toUpperCase() || '';
    } else {
      if (firstName) {
        userInitials += firstName.charAt(0).toUpperCase();
      }
      if (lastName) {
        userInitials += lastName.charAt(0).toUpperCase();
      }
    }

    return userInitials;
  }
}
